var React = require('react');

function IconGood (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("desc",{"key":1}),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1","key":2},React.createElement("g",{"fill":"#142B6F","fillRule":"nonzero"},React.createElement("path",{"d":"M23.2960533,0.83864 C24.3208,1.86544 24.3191467,3.52856 23.2923467,4.5533067 L10.693128,17.1274213 C10.0472169,17.7720442 9.1495126,18.010509 8.3173065,17.8431319 C7.6812958,17.8134263 7.0538065,17.554832 6.5702827,17.066872 L1.0989093,11.545304 C0.0778267,10.5148533 0.0854213,8.8517573 1.115872,7.8306747 C2.1463227,6.809592 3.8094187,6.8171867 4.8305013,7.8476347 L8.6710381,11.7234554 L19.5813867,0.8349333 C20.6081867,-0.1898133 22.2713067,-0.18816 23.2960533,0.83864 Z"})))]);
}

IconGood.defaultProps = {"width":"25","height":"18","version":"1.1","viewBox":"0 0 25 18"};

module.exports = IconGood;

IconGood.default = IconGood;
